import React, { Component } from "react";

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || "Component";
}

let initial = {};
export default function PropTimer(
  propname,
  timeout,
  tvalues,
  changingpropname
) {
  let newpropname = changingpropname || propname + "Changing";

  return function(WrappedComponent) {
    class PropTimerified extends Component {
      timer = -1;
      state = { changing: -1, value: initial };

      static getDerivedStateFromProps(props, state) {
        let newState = { value: props[propname] };
        if (Array.isArray(timeout) && Array.isArray(tvalues)) {
          let idx = timeout.indexOf(props[propname]);
          if (
            idx >= 0 &&
            props[propname] !== state.value &&
            state.value !== initial
          ) {
            newState.changing = tvalues[idx];
          }
        } else {
          if (props[propname] !== state.value && state.value !== initial) {
            newState.changing = timeout;
          }
        }
        return newState;
      }

      componentDidUpdate() {
        if (this.state.changing >= 0) {
          if (this.timer !== -1) {
            clearTimeout(this.timer);
          }
          this.timer = setTimeout(() => {
            this.timer = -1;
            this.setState({ changing: -1 });
          }, this.state.changing);
        }
      }

      componentWillUnmount() {
        if (this.timer !== -1) {
          clearTimeout(this.timer);
        }
      }

      render() {
        let props = { ...this.props };
        if (this.state.changing >= 0) {
          props[newpropname] = true;
        }
        return <WrappedComponent {...props} />;
      }
    }
    PropTimerified.displayName = `PropTimer<${getDisplayName(
      WrappedComponent
    )}>`;
    return PropTimerified;
  };
}
